<template>
  <div id="IndirectHours">

    <v-list  class="pb-0 pt-0 white tileCard mt-3 my-3 mx-3" id="buttonShadow" style="borderRadius:5px" two-line>
      <v-list-item  class="pt-0"  @click="moreInfo(indirectHours.id)">
        <v-list-item-content>
        <v-list-item-title class="font-weight-medium light-blue--text text--darken-3">{{indirectHours.organization_name}}</v-list-item-title>
        <v-list-item-subtitle class=" font-weight-light"> Total Hours: <span class="green--text font-weight-medium">{{totalIndirectInfoHours}}</span> </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="mb-0">

          <v-btn class="" icon  :ripple="false" >
            <v-icon color="grey">mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-item-action>

      </v-list-item >
    </v-list>

  </div>
</template>

<script>
  export default {
    props: ['indirectHours'],
    data() {
      return {
        show: false,
      }
    },
    methods: {
       moreInfo (id) {
        this.$router.push('/dashboard/healthcarehours/indirectexperience/' + id)
      },
    },
    computed: {
      totalIndirectInfoHours() {
        return this.indirectHours.logged_hours.reduce((sum, loggedHours)=> {
          return sum + parseFloat(loggedHours.hours)
        }, 0)
      }
    }
  }
</script>

<style scoped>
.card {
  border-radius: 3px;
}

  #buttonShadow {
    position: sticky;
    box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/IndirectHours/IndirectHours.vue